import { render, staticRenderFns } from "./ComboboxMNN.vue?vue&type=template&id=380f1a0a"
import script from "./ComboboxMNN.vue?vue&type=script&lang=js"
export * from "./ComboboxMNN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports